import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import SupplierForm from 'ui-shared/FormComponents/SupplierForm'

const SupplierCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <SupplierForm />
      </Create>
    </SectionWrapper>
  )
}

export default SupplierCreate
